import script from "./ForumDeliberacaoOfficialDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumDeliberacaoOfficialDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ForumDeliberacaoOfficialDashboard.vue?vue&type=style&index=0&id=42385ee2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42385ee2"]])

export default __exports__